import React from 'react';
// Redux
import { useDispatch } from 'react-redux';
import { EventsFilters } from '../../../redux/types/filtersTypes';
import { setFilters, resetFilters } from '../../../redux/actions/FiltersActions';
// App
import DashboardComponent from '../../../components/DashboardComponent';
import EventListComponent from '../../../components/Events/EventListComponent';
// Other
import { Switch, Route, Redirect, RouteComponentProps } from 'react-router-dom';

export default function EventsRouting(props: RouteComponentProps) {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setFilters(new EventsFilters()));
    return () => {
      dispatch(resetFilters());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DashboardComponent
      title={<h2>Eventos</h2>}
      children={<Switch>
        <Route exact path={props.match.path + '/list'} component={EventListComponent} />
        <Redirect to={props.match.path + '/list'} />
      </Switch>}
    />
  );
}
